<template>
  <div class="loading" v-show="showPopup">
    <van-loading size="25px" type="spinner" text-size="15px" color="#fff">加载中...</van-loading>
  </div>
</template>

<script>
import {Loading} from 'vant';
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPopup: this.value,
    }
  },
  watch: {
    value(val) {
      this.showPopup = val
    },
    showPopup(val) {
      this.$emit('input', val)
    }
  },
  components: {
    [Loading.name]: Loading,
  }
};
</script>
<style lang="scss" scoped>
.loading {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, .8);
  z-index: 99;
  text-align: center;
  padding-top: 190px;
  box-sizing: border-box;

  .van-loading {
    //position: relative;
    //  top:50%;
    //  left:50%;
    //  transform: translate(0%,-50%);
    text-align: center;
  }
}
</style>
